<template>
  <DataTableCell :full-width="fullWidth">
    <v-select
      v-if="editMode"
      v-model="inputVal"
      :items="items"
      :style="{ fontSize }"
      hide-details
      item-title="display_name"
      item-value="value"
      persistent-hint
      solo
      full-width
      variant="plain"
      density="compact"
    />
    <template v-else>
      <span :style="{ fontSize }">{{ inputVal }}</span>
    </template>
  </DataTableCell>
</template>

<script>
import DataTableCell from '@/components/userManagement/DataTableCell.vue'

export default {
  name: 'DataTableDropdownCell',
  components: { DataTableCell },
  props: {
    fullWidth: { type: Boolean, default: false },
    modelValue: { required: false },
    items: { required: false, default: [] },
    editMode: { required: false, default: true },
    fontSize: { type: String, default: '14px' }
  },
  computed: {
    inputVal: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:model-value', val)
      }
    }
  },
  emits: ['input']
}
</script>

<style scoped>
:deep(.v-input__slot) {
  padding: 0 !important;
}

:deep(.v-select__selection) {
  margin: 0 !important;
}

:deep(.v-select__selections) input {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
